import Icon from '@ant-design/icons';
import ZeissButton from '@components/button';
import { Collapse, CollapseProps } from 'antd';
import { ReactElement } from 'react';
import './index.scss';

const caretSvg = (): ReactElement => (
  <svg
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.646469 5.50383L6.00002 0.150277L11.3536 5.50383L10.6465 6.21094L6.00002 1.56449L1.35358 6.21094L0.646469 5.50383Z"
      fill="#0072EF"
    />
  </svg>
);

interface ZeissCollapseInterface extends CollapseProps {
  isExpandBtnShow?: boolean;
  isEditBtnShow?: boolean;
  onExpandClick?: () => void;
  renderExpandIcon?: (data: any) => any;
  isArrowShow?: boolean;
}

const ZeissCollapse = (props: ZeissCollapseInterface): ReactElement => {
  const {
    onExpandClick,
    renderExpandIcon,
    isEditBtnShow = false,
    isArrowShow = true,
    isExpandBtnShow = true
  } = props;
  const onExpandBtnClick = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    onExpandClick?.();
  };
  return (
    <Collapse
      className="zeiss-reset-collapse"
      bordered={false}
      // expandIconPosition="left"
      expandIcon={(expandIconProps) => {
        const { isActive } = expandIconProps;

        return (
          <div className="collapse-handle-wrap">
            {renderExpandIcon ? (
              renderExpandIcon(expandIconProps)
            ) : (
              <>
                {isEditBtnShow && (
                  <ZeissButton type="link" onClick={onExpandBtnClick}>
                    编辑
                  </ZeissButton>
                )}
              </>
            )}

            {isExpandBtnShow && (
              <ZeissButton className="collapse-text" type="link">
                {isActive ? '收起' : '展开'}
              </ZeissButton>
            )}

            {isArrowShow && (
              <Icon
                component={caretSvg}
                className={`${isActive ? '' : 'collapse-active'}`}
              />
            )}
          </div>
        );
      }}
      {...props}
    />
  );
};

export default ZeissCollapse;
